import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * Set the site favicon and mobile device icons.
 *
 * We use react-helmet to set the favicon meta tags as the generated HTML file
 * from react-build is not used, and we roll our own on sangria-server. Yet the
 * app should have control over the favicon, and not the server. This is a
 * suitable workaround.
 */
const Favicon = () => {
  return (
    <Helmet>
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/favicon/apple-touch-icon.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon/favicon-16x16.png"
      />
      <link rel="manifest" href="/favicon/site.webmanifest" />
      <link
        rel="mask-icon"
        href="/favicon/safari-pinned-tab.svg"
        color="#5bbad5"
      />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="theme-color" content="#ffffff" />
    </Helmet>
  );
};

export default Favicon;
